import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const userSingleCourseTinCanTableHeadings = [
	{ data: 'lesson', title: ls('Page') },
	{ data: 'module', title: ls('Module') },
	{ data: 'target', title: ls('Target') },
	{ data: 'action', title: ls('Action') },
	{ data: 'result', title: ls('Result') },
	{ data: 'date', title: ls('Date') }
];

const userSingleCourseTinCanTableData = function(courseID) {
	var tableData = [];

	return tableData;
};

export {
	userSingleCourseTinCanTableHeadings,
	userSingleCourseTinCanTableData
};
